<div>
  <p class="text-aux-black font-bold mb-7" [ngClass]="classNames">{{ title }}</p>
  <p>{{ description }}</p>
  <aux-divider></aux-divider>
</div>
